import { render, staticRenderFns } from "./Assicurazione.vue?vue&type=template&id=60f8397a"
import script from "./Assicurazione.vue?vue&type=script&lang=js"
export * from "./Assicurazione.vue?vue&type=script&lang=js"
import style0 from "./Assicurazione.vue?vue&type=style&index=0&id=60f8397a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports